import {
  GqlModel,
  GqlModelOperator,
  GqlQueryModel,
} from "../graphql/graphql.model";
import gql from "graphql-tag";
import {jsonProperty} from "../json.model";
import {ErrorItemModel} from "../misc/error-item.model";

export class CustomerCreationGqlModel extends GqlQueryModel {
  static mapper: GqlModelOperator<CustomerCreationGqlModel> = GqlModel.buildMapper(CustomerCreationGqlModel, "customerStatus");

  static query: any = gql`
    subscription customerStatus($transactionId: ID) {
      customerStatus(transactionId: $transactionId) {
        __typename
        ... on CustomerStatus {
          status
          messages {
            message
            property
          }
        }
      }
    }
  `;

  static variables(transactionId: string) {
    return {transactionId};
  }

  @jsonProperty("string") status: string;
  @jsonProperty([ErrorItemModel]) messages: ErrorItemModel[];

  constructor(data: any) {
    super(data);
  }
}

export class FleetCreationGqlModel extends GqlQueryModel {
  static mapper: GqlModelOperator<FleetCreationGqlModel> = GqlModel.buildMapper(FleetCreationGqlModel, "FleetStatus");

  static query: any = gql`
    subscription FleetStatus($transactionId: ID) {
      FleetStatus(transactionId: $transactionId) {
        __typename
        ... on FleetStatus {
          status
          messages {
            message
            property
          }
        }
      }
    }
  `;

  static variables(transactionId: string) {
    return {transactionId};
  }

  @jsonProperty("string") status: string;
  @jsonProperty([ErrorItemModel]) messages: ErrorItemModel[];

  constructor(data: any) {
    super(data);
  }
}

export class CustomLabelsUpdateGqlModel extends GqlQueryModel {
  static mapper: GqlModelOperator<CustomLabelsUpdateGqlModel> = GqlModel.buildMapper(CustomLabelsUpdateGqlModel, "CustomLabelsStatus");

  static query: any = gql`
    subscription CustomLabelsStatus($transactionId: ID) {
      CustomLabelsStatus(transactionId: $transactionId) {
        __typename
        ... on CustomLabelsStatus {
          status
          messages {
            message
            property
          }
        }
      }
    }
  `;

  static variables(transactionId: string) {
    return {transactionId};
  }

  @jsonProperty("string") status: string;
  @jsonProperty([ErrorItemModel]) messages: ErrorItemModel[];

  constructor(data: any) {
    super(data);
  }
}
